import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IRegistrationSelectedSectionsModel } from '../models/registration_selected_sections_model';
import { RegistrationFacade } from '../facades/registration_facade';
import { RegistrationSectionFacade } from '../facades/registration_section_facade';

export type UpdateRegistrationFriendlyReminderFlagsCommand = () => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-scheduler')
  .factory(
    'updateRegistrationFriendlyReminderFlagsCommand',
    (
      defineCommandORM: IDefineCommand,
      ngRegistrationSelectedSectionsModel: IRegistrationSelectedSectionsModel,
      ngRegistrationSectionFacade: RegistrationSectionFacade
    ) =>
      defineCommandORM('updateRegistrationFriendlyReminderFlagsCommand', (deferred) => {
        const unscheduledOptionalSectionTypes = ngRegistrationSectionFacade.getUnscheduledOptionalSectionTypes();
        ngRegistrationSelectedSectionsModel.write({
          isAnyScheduledSectionUnselected: ngRegistrationSectionFacade.isAnyScheduledUnselectedSectionsExist(),
          hasAnyScheduledSectionMissingRequirements:
            ngRegistrationSectionFacade.hasAnyScheduledSectionMissingRequirementsExist(),
          unscheduledOptionalSectionTypes: unscheduledOptionalSectionTypes,
          hasAnyOptionalSectionNotScheduled: unscheduledOptionalSectionTypes.length > 0
        });
        return deferred.resolve();
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/commands/update_registration_friendly_reminder_flags_command.ts